import script from "./PatientImg.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientImg.vue?vue&type=script&setup=true&lang=js"

import "./PatientImg.vue?vue&type=style&index=0&id=95fa57c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95fa57c4"]])

export default __exports__